import EventTableHelper from './event-table-helper';
import EventUsersTableHelper from './event-users-table-helper';
import EventAttachmentsTableHelper from './event-attachments-table-helper';
import * as EventCheckLocationHelper from './event-check-location-helper';
import * as EventCheckQrHelper from './event-check-qr-helper';


const EventHelpers = {
    TableMain: EventTableHelper,
    TableUsers: EventUsersTableHelper,
    TableAttachments: EventAttachmentsTableHelper,
    CheckLocation: EventCheckLocationHelper,
    CheckQr: EventCheckQrHelper,
}

export default EventHelpers;
